module.exports = __webpack_public_path__ + "img/project-remove.cc3888ee.svg";